module.exports = __webpack_public_path__ + "img/GR057.2d9dbff2.svg";